import { getConfig, Stage } from '../../../../../../config';

// why converting is needed: blocked by editing images in the konva editor
export const convertToS3Url = (url: string): string => {
  if (url.startsWith('data:')) {
    return url;
  }

  if (url.includes('.s3.')) {
    return url;
  }

  const config = getConfig();
  const stage = config.stage;

  const stagePrefix = stage === Stage.DEV ? 'dev-' : stage === Stage.STAGING ? 'staging-' : '';
  const cloudfrontUrl = `https://${stagePrefix}sourcing.skin-seoul.com/`;
  const s3Url = `https://${stagePrefix}sourcing.skin-seoul.com.s3.us-west-2.amazonaws.com/`;

  if (url.startsWith(cloudfrontUrl)) {
    return url.replace(cloudfrontUrl, s3Url);
  }

  if (url.startsWith(`${stagePrefix}sourcing.skin-seoul.com/`)) {
    return url.replace(
      `${stagePrefix}sourcing.skin-seoul.com/`,
      `${stagePrefix}sourcing.skin-seoul.com.s3.us-west-2.amazonaws.com/`,
    );
  }

  return url;
};

export const convertToCloudFrontUrl = (url: string): string => {
  if (url.startsWith('data:')) {
    return url;
  }

  if (!url.includes('.s3.')) {
    return url;
  }

  const config = getConfig();
  const stage = config.stage;

  const stagePrefix = stage === Stage.DEV ? 'dev-' : stage === Stage.STAGING ? 'staging-' : '';
  const cloudfrontUrl = `https://${stagePrefix}sourcing.skin-seoul.com/`;
  const s3Url = `https://${stagePrefix}sourcing.skin-seoul.com.s3.us-west-2.amazonaws.com/`;

  if (url.startsWith(s3Url)) {
    return url.replace(s3Url, cloudfrontUrl);
  }

  return url;
};
